import {tr} from '../i18n/idioma';

// Nombre en pantalla de cada tipo de empresa (contracts: TIPOS_DE_EMPRESA).
export const NOMBRE_DE_TIPO: Record<string, [string, string]> = {
  supplier: ['Proveedor', 'Supplier'],
  exporter: ['Exportador', 'Exporter'],
  buyer: ['Comprador', 'Buyer'],
  client: ['Cliente', 'Client'],
  trader: ['Trader', 'Trader'],
  importer: ['Importador', 'Importer'],
  agent: ['Agente', 'Agent'],
  shipping_line: ['Naviera', 'Shipping line'],
  invoicing: ['Factura', 'Invoicing'],
  carrier: ['Transportador', 'Carrier'],
  other: ['Otro', 'Other'],
};
export const nombreDeTipo = (r: string) => (NOMBRE_DE_TIPO[r] ? tr(NOMBRE_DE_TIPO[r][0], NOMBRE_DE_TIPO[r][1]) : r);
